import type { ChartHistoryFilterType } from "@roman/shared/constants/predictionChart";
import type { ChartDataPoint } from "@roman/shared/features/chart";

/**
 * Calculate custom ticks for "all" mode - show only one per month
 */
export const getCustomTicksForAll = (
  choiceProbabilityTimeline: ChartDataPoint[],
  displayMode: ChartHistoryFilterType,
): string[] | undefined => {
  if (displayMode !== "all") return undefined;

  const ticks: string[] = [];
  const seenMonths = new Set<string>();

  for (const item of choiceProbabilityTimeline) {
    const [date] = item.time.split(" ");
    const [, month] = date.split("/");

    if (!seenMonths.has(month)) {
      seenMonths.add(month);
      ticks.push(item.time);
    }
  }

  return ticks;
};

/**
 * Calculate custom ticks for "1M" mode - show every 14 days
 */
export const getCustomTicksFor1M = (
  choiceProbabilityTimeline: ChartDataPoint[],
  displayMode: ChartHistoryFilterType,
): string[] | undefined => {
  if (displayMode !== "1M") return undefined;

  const ticks: string[] = [];
  if (choiceProbabilityTimeline.length === 0) return ticks;

  // Add first and last items
  ticks.push(choiceProbabilityTimeline[0].time);

  // Add middle point (around 14 days)
  const middleIndex = Math.floor(choiceProbabilityTimeline.length / 2);
  if (middleIndex > 0 && middleIndex < choiceProbabilityTimeline.length - 1) {
    ticks.push(choiceProbabilityTimeline[middleIndex].time);
  }

  // Add last item if not already added
  const lastItem = choiceProbabilityTimeline[choiceProbabilityTimeline.length - 1];
  if (lastItem.time !== ticks[0]) {
    ticks.push(lastItem.time);
  }

  return ticks;
};

/**
 * Calculate custom ticks for "1W" mode - show every day
 */
export const getCustomTicksFor1W = (
  choiceProbabilityTimeline: ChartDataPoint[],
  displayMode: ChartHistoryFilterType,
): string[] | undefined => {
  if (displayMode !== "1W") return undefined;

  const ticks: string[] = [];
  const seenDays = new Set<string>();

  for (const item of choiceProbabilityTimeline) {
    const [date] = item.time.split(" ");

    if (!seenDays.has(date)) {
      seenDays.add(date);
      ticks.push(item.time);
    }
  }

  return ticks;
};
